import type { Locale } from './types';

export const SUPPORTED_LOCALES = ['en', 'zh-CN', 'ms'] as const satisfies readonly Locale[];

export const DEFAULT_LOCALE: Locale = 'en';
